var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4861 13.8467C28.1713 14.5308 28.1713 15.6392 27.4861 16.3243L17.7033 26.1097C17.3466 26.4632 16.9086 26.7228 16.4268 26.8667L12.642 27.9804C12.4662 28.0305 12.2762 27.9835 12.1466 27.8521C12.0171 27.7239 11.9687 27.5331 12.0204 27.3579L13.1335 23.5726C13.2752 23.0908 13.5358 22.6529 13.8909 22.2962L23.6756 12.5131C24.3608 11.829 25.4683 11.829 26.1534 12.5131L27.4861 13.8467ZM22.6682 14.9353L25.0647 17.3034L26.7791 15.6173C27.0732 15.3232 27.0732 14.8477 26.7791 14.5546L25.4464 13.221C25.1523 12.9279 24.6767 12.9279 24.3827 13.221L22.6682 14.9353ZM21.9612 15.6423L14.5989 23.0064C14.362 23.241 14.1884 23.5351 14.0939 23.8573L13.2398 26.7604L16.1422 25.9063C16.4644 25.8125 16.7585 25.6373 16.9931 25.3995L24.3295 18.0386L21.9612 15.6423Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fd122f60f6aef4fadddd1a61cafe9333.svg";
export { ForwardRef as ReactComponent };